import _ from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';

export const extractUGC = ({
    general,
    overview,
    description,
    sellerCard,
    faq,
    packages = {},
    studio = {}
}) => {
    const { gig } = overview;
    const { title } = gig;
    const { isStudio } = general;

    return {
        gigTitle: `${getTitlePrefix({ isStudio })} ${title}`,
        description: _.pick(description, 'content'),
        sellerCard: _.pick(sellerCard, ['description', 'oneLiner']),
        studio: extractStudioContent(studio),
        faq,
        listings: {},
        galleryReviews: {},
        packages: extractPackagesContent(packages)
    };
};

export const getTitlePrefix = ({ isStudio }) => {
    const { locale } = getContext();
    const key = isStudio ? 'our_studio_will' : 'i_will';

    return i18n.t(`gig_page_perseus.general.${key}`, { $scope: locale });
};

const extractPackagesContent = ({ packageList = [] }) => {
    const packages = {};

    packageList.forEach(({ title, description, customExtras = [], id }) => {
        packages[id] = {
            title,
            description,
            customExtras: customExtras.map(({ label, buyerTooltip }) => ({ label, buyerTooltip }))
        };
    });

    return packages;
};

const extractStudioContent = ({ info }) => _.pick(info, ['tagline']);
